var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnHandleSpacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 20C17.3358 20 17 20.3358 17 20.75C17 21.1642 17.3358 21.5 17.75 21.5H29.75C30.1642 21.5 30.5 21.1642 30.5 20.75C30.5 20.3358 30.1642 20 29.75 20H17.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 26C17.3358 26 17 26.3358 17 26.75C17 27.1642 17.3358 27.5 17.75 27.5H29.75C30.1642 27.5 30.5 27.1642 30.5 26.75C30.5 26.3358 30.1642 26 29.75 26H17.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnHandleSpacing);
export default __webpack_public_path__ + "static/media/icn-handle-spacing.309a0e661dccb9f0797cc26345f4f785.svg";
export { ForwardRef as ReactComponent };